// @ts-nocheck
const CRC32_TABLE = (() => {
  const table = new Uint32Array(256);

  for (let byteValue = 0; byteValue < 256; byteValue++) {
    let crcValue = byteValue;

    for (let bitIndex = 0; bitIndex < 8; bitIndex++)
      crcValue = (crcValue & 1) ? (0xEDB88320 ^ (crcValue >>> 1)) : (crcValue >>> 1);

    table[byteValue] = crcValue;
  }

  return table;
})();

function crc32(data) {
  let crc = 0xFFFFFFFF;

  for (let index = 0; index < data.length; index++)
    crc = (crc >>> 8) ^ CRC32_TABLE[(crc ^ data[index]) & 0xFF];

  return (crc ^ 0xFFFFFFFF) >>> 0;
}

async function deflateRaw(data) {
  const stream = new Blob([data]).stream().pipeThrough(new CompressionStream("deflate-raw"));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

function dosDateTime(dateTime) {
  const time = ((dateTime.getHours() & 0x1F) << 11)
    | ((dateTime.getMinutes() & 0x3F) << 5)
    | (Math.floor(dateTime.getSeconds() / 2) & 0x1F);

  const date = (((dateTime.getFullYear() - 1980) & 0x7F) << 9)
    | (((dateTime.getMonth() + 1) & 0x0F) << 5)
    | (dateTime.getDate() & 0x1F);

  return { time: time, date: date };
}

class ZipFileOptions {
  constructor() {
    this.useCompression = false;
  }
}

export class ZipBuilder {
  constructor() {
    this.parts = [];
    this.entries = [];
    this.offset = 0;
  }

  async addFile(name, blob, options = new ZipFileOptions()) {
    const data = new Uint8Array(await blob.arrayBuffer());
    const compressed = options.useCompression ? await deflateRaw(data) : data;
    const compressionMethod = options.useCompression ? 8 : 0;
    const checksum = crc32(data);
    const nameBytes = new TextEncoder().encode(name);
    const dosTimestamp = dosDateTime(new Date());

    const header = new ArrayBuffer(30 + nameBytes.length);
    const view = new DataView(header);

    view.setUint32(0, 0x04034b50, true);
    view.setUint16(4, 20, true);
    view.setUint16(6, 0x0800, true);
    view.setUint16(8, compressionMethod, true);
    view.setUint16(10, dosTimestamp.time, true);
    view.setUint16(12, dosTimestamp.date, true);
    view.setUint32(14, checksum, true);
    view.setUint32(18, compressed.length, true);
    view.setUint32(22, data.length, true);
    view.setUint16(26, nameBytes.length, true);
    view.setUint16(28, 0, true);

    new Uint8Array(header, 30).set(nameBytes);

    this.entries.push({
      nameBytes: nameBytes,
      compressionMethod: compressionMethod,
      checksum: checksum,
      compressedSize: compressed.length,
      uncompressedSize: data.length,
      dosTimestamp: dosTimestamp,
      offset: this.offset
    });

    this.parts.push(new Uint8Array(header));
    this.offset += header.byteLength;

    this.parts.push(compressed);
    this.offset += compressed.length;
  }

  build() {
    const directoryStart = this.offset;

    for (const entry of this.entries) {
      const centralDirectoryHeader = new ArrayBuffer(46 + entry.nameBytes.length);
      const view = new DataView(centralDirectoryHeader);

      view.setUint32(0, 0x02014b50, true);
      view.setUint16(4, 20, true);
      view.setUint16(6, 20, true);
      view.setUint16(8, 0x0800, true);
      view.setUint16(10, entry.compressionMethod, true);
      view.setUint16(12, entry.dosTimestamp.time, true);
      view.setUint16(14, entry.dosTimestamp.date, true);
      view.setUint32(16, entry.checksum, true);
      view.setUint32(20, entry.compressedSize, true);
      view.setUint32(24, entry.uncompressedSize, true);
      view.setUint16(28, entry.nameBytes.length, true);
      view.setUint16(30, 0, true);
      view.setUint16(32, 0, true);
      view.setUint16(34, 0, true);
      view.setUint16(36, 0, true);
      view.setUint32(38, 0, true);
      view.setUint32(42, entry.offset, true);

      new Uint8Array(centralDirectoryHeader, 46).set(entry.nameBytes);

      this.parts.push(new Uint8Array(centralDirectoryHeader));
      this.offset += centralDirectoryHeader.byteLength;
    }

    const directorySize = this.offset - directoryStart;

    const endOfCentralDirectoryRecord = new ArrayBuffer(22);
    const view = new DataView(endOfCentralDirectoryRecord);

    view.setUint32(0, 0x06054b50, true);
    view.setUint16(4, 0, true);
    view.setUint16(6, 0, true);
    view.setUint16(8, this.entries.length, true);
    view.setUint16(10, this.entries.length, true);
    view.setUint32(12, directorySize, true);
    view.setUint32(16, directoryStart, true);
    view.setUint16(20, 0, true);

    this.parts.push(new Uint8Array(endOfCentralDirectoryRecord));

    return new Blob(this.parts, { type: "application/zip" });
  }
}
